import { types, SnapshotIn } from 'mobx-state-tree';
import { IcsCompany } from '@icecreamsocial/mst-models';
/**
 * @module BusinessPreprocessor
 * @category Shared
 * @subcategory Models
 * @description
 * Formats a snapshot for an IcsCompany model
 */

const Business = types.snapshotProcessor(
	IcsCompany,
	{
		/**
		 * format an incoming snapshot of an ICS payment gateway
		 * @param {SnapshotIn<typeof IcsCompany>} snapshot
		 */
		preProcessor(snapshot) {
			if (snapshot === null || snapshot === undefined) return undefined;

			const { clientId, processorId, ...rest } = snapshot;

			return {
				...rest,
				// marketVertical: vertical,
				clientId: clientId ? `${clientId}` : null,
				processorId: processorId
					? `${processorId}`
					: null,
			};
		},
	},
	'IcsBusiness'
);

export default Business;
